import { Component } from '@angular/core';
import { EntityTypeEnum } from "src/app/core/enums/entity-type-id-enum";
import { GlobalComponent } from 'src/app/global-component';
import { environment } from 'src/environments/environment';
import { BaseListComponent } from '../base-list/base-list.component';
import { SafeResourceUrl } from '@angular/platform-browser';
import { DefaultImageService } from 'src/app/core/services/default-image.service';

@Component({
  selector: 'app-base-list-with-entity-photos',
  templateUrl: './base-list-with-entity-photos.component.html',
  styleUrls: ['./base-list-with-entity-photos.component.scss']
})
export abstract class BaseListWithEntityPhotosComponent extends BaseListComponent {

  private preloadedPhotos: { id: string; image?: SafeResourceUrl; }[] = [];
  protected defaultImageService: DefaultImageService = new DefaultImageService()
  //added early version of image load control with preLoadedPhotos, 
  getEntityPhoto(entity: any, entityTypeEnum: EntityTypeEnum) {
    if (entity.id && entity.profilePhotoFileId) {
      var photoUrl = this.checkIfImageHasBeenLoaded(entity.profilePhotoFileId);

      if (photoUrl !== undefined) {
        entity.listPhoto = photoUrl;
      } else {
        this.myFileApiService.getEntityFile(entityTypeEnum, entity.id, entity.profilePhotoFileId).subscribe(result => {
          if (result) {
            var reader = new FileReader();
            reader.readAsDataURL(result);
            reader.onload = () => {
              if (reader.result) {
                var sanitizedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${reader.result.toString().split(',')[1]}`);
                entity.listPhoto = sanitizedUrl;
                this.preloadedPhotos.push({ id: entity.profilePhotoFileId, image: sanitizedUrl });
              }
            }
          }
        })
      }
    }
  }

  profilePhotoPNGTransform(profilePhoto: any) {
    if (profilePhoto && profilePhoto.listPhoto) {
      return profilePhoto.listPhoto;
    }
    if (profilePhoto !== undefined) {
      profilePhoto.listPhoto = this.defaultImageService.getDefaultUserImage(profilePhoto.fullName);
      return profilePhoto.listPhoto;
    }
    return this.defaultImageService.getDefaultUserImage();

  }


  checkIfImageHasBeenLoaded(photoFileId: string): SafeResourceUrl | undefined {

    var index = this.preloadedPhotos.findIndex(x => x.id === photoFileId)

    if (index !== -1) {
      return this.preloadedPhotos[index].image;
    }

    return undefined;
  }
}
